import { getPaddingString, formFieldErrorHtml, toRGBA } from "../parser/utils";
import { getFormLableStyleStr } from "./FormBaseStyle";

export default ({ id, type, data, root }) => {
  const {
    label,
    placeholder,
    required,
  } = data;

  const {
    formBorderWidth,
    formBorderStyle,
    formBorderColor,
    formBorderRadius,
    formTextColor
  } = root.data;
  

  const labelStyle = getFormLableStyleStr(data, root.data);

  return `
    <div class="rip-field-group" style="text-align: left;${getPaddingString(
      data
    )}">
      <label for="${id}" style="${labelStyle}">
        ${
          required
            ? '<span style="color: #ff4d4f; margin-right: 4px;">*</span>'
            : ""
        }${label}
      </label>
      <input
        id="${id}"
        name="${id}"
        class="rip-form-input"
        style="
          height: 38px;
          padding: 0 8px;
          width: 100%;
          border-width: ${formBorderWidth}px;
          border-style: ${formBorderStyle};
          border-color: ${toRGBA(formBorderColor)};
          border-radius: ${formBorderRadius}px;
          color: ${toRGBA(formTextColor)};
        "
        type="text"
        placeholder="${placeholder}"
      />
      ${formFieldErrorHtml({ id })}
    </div>
  `;
};
